module.exports = __webpack_public_path__ + "static/img/logo6.ed9c5e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/solutions/logo6.png
// module id = xCzf
// module chunks = 0